export default __webpack_public_path__ + "static/media/rejected.e6e33443.png";